import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { useSettings } from '@/hooks/useSettings.hook';

import { RoutesEnum } from '@/enums/routes.enum';

import { IS_HEADER_HIDDEN } from '@/utils/constants';

export const Main = styled('main')(() => {
  const { isDesktop, isMobile } = useSettings();
  const { pathname } = useLocation();
  const isUnsubscribe = pathname === RoutesEnum.unsubscribe;
  const calcPaddingTop = () => {
    if (IS_HEADER_HIDDEN && isDesktop) return '40px';
    if (!IS_HEADER_HIDDEN && isDesktop && !isUnsubscribe) return '130px';
    if (isMobile) return '0';
    return '20px';
  };
  return {
    width: '100%',
    maxWidth: '630px',
    margin: '0 auto',
    height: 'auto',
    minHeight: '700px',
    paddingTop: calcPaddingTop(),
  };
});

export const MainInner = styled('div')(() => {
  const { pathname } = useLocation();
  const { isMobile } = useSettings();
  const isGameFieldPage = pathname === RoutesEnum.game;
  const isHowToPlayPage = pathname === RoutesEnum.help;
  const isHomePage = pathname === RoutesEnum.play;

  const calcContentXGaps = () => {
    if (isHowToPlayPage || isHomePage) {
      return '0';
    }
    if (isGameFieldPage && isMobile) {
      return '0';
    }
    return '0 15px';
  };

  return {
    width: '100%',
    padding: calcContentXGaps(),
  };
});
